import type { HTMLAttributes, MutableRefObject, ReactNode } from 'react';
import { css, cx } from '@eti/styles';
import { breakpoints, Stack } from '@etg/wings';

const layoutStyles = css`
  display: grid;
  row-gap: 16px;

  @media (min-width: ${breakpoints._970}) {
    column-gap: 24px;
    grid-template-columns: [main] 4fr [sidebar] 2fr;
    grid-template-rows: repeat(4, auto);
  }

  & > * {
    grid-column: main;
  }
`;

const layoutSidebarStyles = css`
  grid-column: sidebar;
  grid-row: 1 / span 4;
  position: relative;

  &:empty {
    display: none;
  }
`;

interface LayoutProps extends HTMLAttributes<HTMLDivElement> {
  bottomContent: ReactNode;
  className?: string;
  children: ReactNode;
  header: ReactNode;
  sidebar?: ReactNode;
  sidebarRef?: MutableRefObject<HTMLDivElement>;
}

const Layout = ({
  bottomContent,
  className,
  children,
  header,
  sidebar,
  sidebarRef,
  ...props
}: LayoutProps) => {
  return (
    <div className={cx(layoutStyles, className)} data-testid="payment-layout" {...props}>
      <Stack data-testid="payment-layout-header">{header}</Stack>
      <Stack data-testid="payment-layout-main">{children}</Stack>
      <div className={layoutSidebarStyles} data-testid="payment-layout-sidebar" ref={sidebarRef}>
        {sidebar}
      </div>
      <Stack data-testid="payment-layout-bottom">{bottomContent}</Stack>
    </div>
  );
};

export default Layout;
